import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=bd1df9a8&scoped=true&"
import script from "./rooms.vue?vue&type=script&lang=js&"
export * from "./rooms.vue?vue&type=script&lang=js&"
import style0 from "./rooms.vue?vue&type=style&index=0&id=bd1df9a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1df9a8",
  null
  
)

export default component.exports